import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { HeaderStyle, HeaderSpan, PanelContainer } from './Panel.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface PropsType {
    title: string | JSX.Element;
    titleDataTest: string;
    children: React.ReactNode;
    isAzMobile?: boolean;
}

export const Panel = observer('Panel', (props: PropsType): JSX.Element => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const { title, children, isAzMobile = false, titleDataTest } = props;

    return (
        <PanelContainer
            isAzMobile={isAzMobile}
            data-test={titleDataTest}
        >
            <HeaderStyle>
                <HeaderSpan variant={configState.componentVariants.navMenuVariant}>{title}</HeaderSpan>
            </HeaderStyle>
            {children}
        </PanelContainer>
    );
});
